var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResponsiveIllustration2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "424px",
    height: "316px",
    viewBox: "0 0 424 316",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "responsive_illustration_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-4.9%",
    y: "-5.8%",
    width: "109.7%",
    height: "111.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-27.3%",
    y: "-15.0%",
    width: "154.5%",
    height: "130.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-14.6%",
    y: "-10.8%",
    width: "129.1%",
    height: "121.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "F24-ordinario",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "F24_responsive-Copy",
    transform: "translate(-154.000000, -281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "responsive_illustration_2",
    transform: "translate(158.875758, 296.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.922315,0 L17.072863,0 C13.7169975,0 11,2.83515383 11,6.32605753 L11,184.082488 L11,203.222187 L11,212.409918 C11,215.908054 13.7169975,218.740797 17.072863,218.740797 L128.744593,218.740797 L128.744593,222.410103 C128.744593,232.251173 125.48275,243.136139 120.002949,248.770284 L111.3939,257.263691 L111.3939,260 L219.601278,260 L219.601278,257.263691 L210.992229,248.770284 C205.512429,243.136139 202.250585,232.251173 202.250585,222.410103 L202.250585,209.097417 L313.922315,209.097417 C317.280592,209.097417 320,206.264674 320,202.766537 L320,193.578807 L320,174.439108 L320,6.32605753 C320,2.83515383 317.280592,0 313.922315,0",
    id: "Fill-1",
    fill: "#9D9D9D",
    filter: "url(#filter-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,283.120482 C404,284.710843 402.717586,286 401.135542,286 L351.862061,286 C350.280017,286 349,284.710843 349,283.120482 L349,188.881928 C349,187.289157 350.280017,186 351.862061,186 L401.135542,186 C402.717586,186 404,187.289157 404,188.881928 L404,283.120482 Z",
    id: "Fill-11",
    fill: "#9D9D9D",
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,280.637566 C334,283.600571 331.600601,286 328.637634,286 L236.362366,286 C233.399399,286 231,283.600571 231,280.637566 L231,152.362434 C231,149.399429 233.399399,147 236.362366,147 L328.637634,147 C331.600601,147 334,149.399429 334,152.362434 L334,280.637566 Z",
    id: "Fill-17",
    fill: "#9D9D9D",
    filter: "url(#filter-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.40745,249.436657 C194.940558,243.982175 191.682559,235.06152 191.682559,225.533191 L191.682559,216 L118.319847,216 L118.319847,225.533191 C118.319847,235.06152 115.061848,243.982175 109.594956,249.436657 L101,258 L209,258 L200.40745,249.436657 Z",
    id: "Fill-4",
    fill: "#660209"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#99030E",
    points: "101 260 209 260 209 257 101 257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,204 L309,15.0682298 C309,11.7197425 306.280592,9 302.922315,9 L6.07527385,9 C2.71699747,9 0,11.7197425 0,15.0682298 L0,204 L309,204 Z",
    id: "Fill-7",
    fill: "#99030E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,186 L0,213.788627 C0,217.219413 2.71699747,220 6.07527385,220 L302.922315,220 C306.280592,220 309,217.219413 309,213.788627 L309,186 L0,186 Z",
    id: "Fill-8",
    fill: "#99030E"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#F0F0F0",
    points: "10 176 300 176 300 19 10 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FFFFFF",
    points: "300 176 180.975932 19 300 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,290.120482 C397,291.710843 395.717586,293 394.135542,293 L344.862061,293 C343.280017,293 342,291.710843 342,290.120482 L342,195.881928 C342,194.289157 343.280017,193 344.862061,193 L394.135542,193 C395.717586,193 397,194.289157 397,195.881928 L397,290.120482 Z",
    id: "Fill-12",
    fill: "#99030E"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#F0F0F0",
    points: "344 286 395 286 395 201 344 201"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#FFFFFF",
    points: "395 259 346 201 395 201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,289.50283 C374,290.332075 373.442644,291 372.753593,291 L366.246407,291 C365.557356,291 365,290.332075 365,289.50283 C365,288.673585 365.557356,288 366.246407,288 L372.753593,288 C373.442644,288 374,288.673585 374,289.50283",
    id: "Fill-16",
    fill: "#660209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,287.637566 C327,290.600571 324.600601,293 321.637634,293 L229.362366,293 C226.399399,293 224,290.600571 224,287.637566 L224,159.362434 C224,156.399429 226.399399,154 229.362366,154 L321.637634,154 C324.600601,154 327,156.399429 327,159.362434 L327,287.637566 Z",
    id: "Fill-18",
    fill: "#99030E"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#F0F0F0",
    points: "228 283 323 283 323 163 228 163"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#FFFFFF",
    points: "323 251 255 163 323 163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,288 C281,289.105691 280.257036,290 279.33621,290 L270.661538,290 C269.745216,290 269,289.105691 269,288 C269,286.894309 269.745216,286 270.661538,286 L279.33621,286 C280.257036,286 281,286.894309 281,288",
    id: "Fill-21",
    fill: "#660209"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#DF0514",
    points: "383 226.498076 379.501924 223 369.5 233.001924 359.498076 223 356 226.498076 366.001924 236.5 356 246.501924 359.498076 250 369.5 239.998076 379.501924 250 383 246.501924 372.998076 236.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#DF0514",
    points: "291 214.498076 287.501924 211 277.5 221.001924 267.498076 211 264 214.498076 274.001924 224.5 264 234.501924 267.498076 238 277.5 227.998076 287.501924 238 291 234.501924 280.998076 224.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1-Copy",
    fill: "#2B9E1B",
    points: "176.729935 63 151.761723 112.651551 134.388366 82.4219653 130.124242 84.8423838 152.051565 123 181.124242 65.1859481"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsiveIllustration2);
export default __webpack_public_path__ + "static/media/responsive_illustration_2.d251f0c94b87fcdc45523efec289bcd3.svg";
export { ForwardRef as ReactComponent };